// HOOKS
import { useEffect, useState } from "react";
// COMPONENTS
import DropdownButton from "../buttons/dropdown.button";

const DEFAULT_CLASSNAMES = {
  container: "flex flex-col  gap-1",
  checkbox: "hover:cursor-pointer dark:accent-darkPrimary accent-lightPrimary",
  checkboxContainer:
    "shadow shadow-secondary text-secondary bg-slate-50 flex flow-row rounded px-2",
  dropDownLabel:
    "hover:cursor-pointer w-full flex self-start p-2 text-sm font-ubuntuRegular",
};

const MultiSelectDropdown = ({
  options = [],
  handleChange = () => {},
  classNames = DEFAULT_CLASSNAMES,
  label = "",
  search = {
    enabled: false,
    placeholder: "Search...",
    handleSearch: () => {},
  },
}) => {
  const [showCount, setShowCount] = useState(0);
  useEffect(() => {
    setShowCount(options.filter((column) => column?.show).length);
  }, [options]);

  return (
    <DropdownButton
      classNames={classNames?.dropdownButton}
      label={label}
      value={showCount}
    >
      <div className={classNames?.container || DEFAULT_CLASSNAMES.container}>
        {search.enabled && (
          <div className="flex p-1">
            <input
              type="search"
              placeholder="Search..."
              className=" p-2 rounded w-full shadow-black shadow-sm"
              onChange={search.handleSearch}
            />
          </div>
        )}

        {options &&
          options.map((column) => (
            <div
              key={column.id}
              className={
                classNames?.checkboxContainer ||
                DEFAULT_CLASSNAMES.checkboxContainer
              }
            >
              <input
                type="checkbox"
                id={column?.id}
                name={column?.id}
                checked={column?.show}
                onChange={handleChange}
                className={classNames?.checkbox || DEFAULT_CLASSNAMES.checkbox}
              />
              <label
                className={
                  classNames?.dropDownLabel || DEFAULT_CLASSNAMES.dropDownLabel
                }
                htmlFor={column?.id}
              >
                {column?.label}
              </label>
            </div>
          ))}
      </div>
    </DropdownButton>
  );
};

export default MultiSelectDropdown;
